(function() {
    'use strict';
    
a3_cabin_reports.controller('CalendarRedirectModalCtrl', CalendarRedirectModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name CalendarRedirectModalCtrl
    * @description 
    * Modal to redirect to Calendar after all mandatory memos are read
    * @ngInject
    */
function CalendarRedirectModalCtrl($scope, $location, $uibModalInstance) {
        $scope.gotoCalendar = gotoCalendar;

        
        function gotoCalendar(){
            cancel();
            $location.path('/');
        }
          
        /**
        * Closes modal
        * @memberof CalendarRedirectModalCtrl
        */
        function cancel() {
            $uibModalInstance.close('cancel');
        }
    }

    
})();